import {UmpireTeam} from '../umpire-team';
import {UmpireSquadPlayer} from '../umpire-squad-player';
import {UmpireSeason} from '../umpire-season';
import {UmpireImage} from '../umpire-image';
import {UmpireSquadStats} from '../umpire-squad-stats';
import {UmpireSquadStaffMember} from '../umpire-squad-staff-member';

export interface UmpireSquad {
  type: string;

  name: string;

  id: string;

  squad_players: UmpireSquadPlayer[];

  squad_staff_members: UmpireSquadStaffMember[];

  squad_staff_members_order: SquadStaffMembersOrder[];

  relationshipNames: string[];

  season: UmpireSeason;

  team: Partial<UmpireTeam>;

  club_code: string | null;

  club_name: string | null;

  club_image: Partial<UmpireImage>;

  stats: UmpireSquadStats;

  slug: string | null;

  squad_players_count: number;
}

export interface SquadStaffMembersOrder {
  squad_staff_member_id: number;
  squad_staff_member_index: number;
}
